export default __webpack_public_path__ + "static/media/Path3540.655de9f0.svg";